import { render, staticRenderFns } from "./PartsBases.vue?vue&type=template&id=371308e2&scoped=true&"
import script from "./PartsBases.vue?vue&type=script&lang=js&"
export * from "./PartsBases.vue?vue&type=script&lang=js&"
import style0 from "./PartsBases.vue?vue&type=style&index=0&id=371308e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371308e2",
  null
  
)

export default component.exports